const phoneNumberRegex = /\+1\d{10}$/;

export const phoneFormatter = {
  stringToPretty: (phoneNumber: string): string => {
    if (!phoneNumberRegex.test(phoneNumber)) return phoneNumber;

    const areaCode = phoneNumber.substring(2, 5);
    const centerThree = phoneNumber.substring(5, 8);
    const lastFour = phoneNumber.substring(8, 12);

    return `(${areaCode}) ${centerThree}-${lastFour}`;
  },
};
